import Datepicker from './datepicker';
import './datepicker.scss';

// Expose like Bootstrap's own components, e.g. `bootstrap.Datepicker.getInstance(el)`
globalThis.bootstrap = globalThis.bootstrap || {};
globalThis.bootstrap.Datepicker = Datepicker;

export default Datepicker;
